<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Report Cash Flow Dimension
        <span class="badge badge-info ml-2" v-if="filter.sourceData">
          {{ filter.sourceData === 'BUKU' ? 'Source: Journal GL (Buku)' : 'Source: Bank Trx (Tranbank)' }}
        </span>
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="process()">
            <i class="fa fa-play"></i>
            Process
          </button>
          <button class="btn btn-primary mr-1" @click="print()">
            <i class="fa fa-print"></i>
            print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <!-- <b-row >
                <b-col lg="8">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">Dimension</span></b-input-group-prepend>
                        <b-form-select v-model="filter.DimCol" :plain="true" :options="cfdimension" :state="!$v.filter.DimCol.$error"></b-form-select>
                        <b-input-group-prepend><span class="p-2">Trx. Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" placeholder="from date" readonly></b-form-input>
                        <b-form-input v-model="filter.tgl2" type="date" placeholder="until date" @change="updateTgl1" :state="!$v.filter.tgl2.$error" class="ml-1"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row > -->

      <b-row>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 100px"
                >Line Layout</label
              ></b-input-group-prepend
            >
            <b-form-select
              v-model="filter.layout"
              :plain="true"
              :options="layouts"
              :state="!$v.filter.layout.$error"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2">Dimension</span></b-input-group-prepend
            >
            <b-form-select
              v-model="filter.DimCol"
              :plain="true"
              :options="cfdimension"
              :state="!$v.filter.DimCol.$error"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2">Source Data</span></b-input-group-prepend
            >
            <b-form-select
              v-model="filter.sourceData"
              :plain="true"
              :options="sourceDataOptions"
            ></b-form-select>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 100px"
                >Trx. Date Range</label
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="filter.tgl1"
              type="date"
              placeholder="from date"
              :state="!$v.filter.tgl1.$error"
              class="mr-1"
            ></b-form-input>
            <b-form-input
              v-model="filter.tgl2"
              type="date"
              placeholder="until date"
              @change="updateTgl1"
              :state="!$v.filter.tgl2.$error"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2"
                >Max. Dimension Col.</span
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="filter.DimLimit"
              type="number"
              :min="3"
              :state="!$v.filter.DimLimit.$error"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="pl-2 pt-2 mr-2"
                >Sort By</span
              ></b-input-group-prepend
            >
            <b-form-select
              v-model="filter.sortBy"
              :plain="true"
              :options="revenueCost"
              :state="!$v.filter.sortBy.$error"
            ></b-form-select>
          </b-input-group>
        </b-col>
      </b-row>

      <b-card no-body>
        <div class="report-wraper">
          <table style="width: 100%">
            <thead>
              <tr>
                <th>Description</th>
                <th
                  style="text-align: right"
                  v-for="kol in rptPnl.koloms"
                  :key="kol.kode"
                >
                  {{ kol.nama }}
                </th>
                <th style="text-align: right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rptPnl.lines" :key="row.idrowunik">
                <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                <td
                  :class="row.kelas"
                  v-for="kol in rptPnl.koloms"
                  :key="kol.kode"
                  style="text-align: right"
                >
                  <b-link
                    v-if="(row.kode || row.rumus) && isValueNonZero(row[`K${kol.kode.trim()}`])"
                    @click="drillDownListTrx(kol, row)"
                  >
                    {{ row[`K${kol.kode.trim()}`] | numFormat("0,0.00") }}
                  </b-link>
                  <span v-else-if="row.kode || row.rumus">
                    {{ row[`K${kol.kode.trim()}`] | numFormat("0,0.00") }}
                  </span>
                </td>
                <td
                  :class="row.kelas"
                  v-if="row.kode || row.rumus"
                  style="text-align: right"
                >
                  <b-link
                    v-if="isValueNonZero(row.total)"
                    @click="drillDownTotal(row)"
                  >
                    {{ row.total | numFormat("0,0.00") }}
                  </b-link>
                  <span v-else>
                    {{ row.total | numFormat("0,0.00") }}
                  </span>
                </td>
                <td v-else></td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      ok-only
    >
      <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.report-wraper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;

  table {
    font-size: smaller;
    th {
      border-bottom: 1px solid #d1d1d1;
      padding: 0 15px;
      height: 30px;
      background: #e8e8e8;
    }
    tbody tr:hover {
      background-color: rgba(91, 192, 222, 0.2) !important;
      cursor: default;
    }

    td {
      border-bottom: 1px solid #f5f5f5;
      padding: 0 10px;
      height: 25px;
    }

    td.tebal {
      font-weight: bold;
    }

    td.subtotal {
      border-top: 2px solid #000 !important;
    }

    td.total {
      border-top: 2px solid #000 !important;
      background: #e6e6e6 !important;
    }

    td.grdtotal {
      border-top: 2px solid #000 !important;
      border-bottom: 2px solid #000 !important;
      background: #e6e6e6 !important;
    }
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import cashflow from "../../apis/cashflow";
import toastr from "mini-toastr";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
      layout: { required },
      DimCol: { required },
      tgl1: { required },
      tgl2: { required },
      DimLimit: { required },
      sortBy: { required },
    },
  },
  data() {
    return {
      cfdimension: [{ value: "bank", text: "Bank/Cash Account" }],
      sourceDataOptions: [
        { value: "TRANBANK", text: "Bank Trx (Operasional)" },
        { value: "BUKU", text: "Journal GL (Tabel Buku)" },
      ],
      filter: {
        DimCol: "",
        layout: "",
        tgl1: "",
        tgl2: "",
        DimLimit: 10,
        sortBy: "RECEIPT",
        sourceData: "TRANBANK",
      },
      isLoading: false,
      layouts: [],
      horizontal: true,
      lkuDimShow: false,
      reportUrl: null,
      showReport: false,
      rptPnl: { lines: [], koloms: [] },
      revenueCost: ["RECEIPT", "PAYMENT"],
    };
  },
  components: { Loading },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    dimCol() {
      return this.filter.DimCol;
    },
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
      return this.filter.layout;
    },
  },
  watch: {
    layout: async function (newval) {
      this.rptPnl.lines = await cashflow.layoutcashflow({ layout: newval });
    },
  },
  created: async function () {
    this.layouts = await cashflow.layoutcashflow_combo();
    var tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
      .add(1, "M")
      .subtract(1, "day");
    var tgl1 = moment(tgl2.format("YYYY") + "-01-01", "YYYY-MM-DD");
    this.filter.tgl1 = tgl1.format("YYYY-MM-DD");
    this.filter.tgl2 = tgl2.format("YYYY-MM-DD");
    this.filter.DimCol = "bank";
    setTimeout(() => {
      this.cfdimension = this.cfdimension.concat(this.dimension);
      console.log("this.cfdimension : ", this.cfdimension);
    }, 500);
    this.$watch("dimCol", function (newval) {
      const ada = this.cfdimension.find((d) => d.value === newval);
      if (ada) {
        this.filter.DimColInfo = ada.text;
      }
    });
  },
  methods: {
    updateTgl1: function () {
      var tgl2 = moment(this.filter.tgl2, "YYYY-MM-DD");
      var tgl1 = moment(tgl2.format("YYYY") + "-01-01", "YYYY-MM-DD");
      this.filter.tgl1 = tgl1.format("YYYY-MM-DD");
    },
    process: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const model = {};
          for (var key in this.filter) {
            model[key] = this.filter[key];
          }
          model.tgl1 = moment(this.filter.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.filter.tgl2).format("YYYY-MM-DD");
          let arrRes = await cashflow.cashflowdim10(model);
          this.rptPnl.lines = arrRes[0];
          this.rptPnl.koloms = arrRes[1];
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    print: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          this.reportUrl = null; this.showReport = true;
          const model = {};
          for (var key in this.filter) {
            model[key] = this.filter[key];
          }
          model.tgl1 = moment(this.filter.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.filter.tgl2).format("YYYY-MM-DD");
          this.reportUrl = await cashflow.cashflowdim10print(model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportxls: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const model = {};
          for (var key in this.filter) {
            model[key] = this.filter[key];
          }
          model.tgl1 = moment(this.filter.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.filter.tgl2).format("YYYY-MM-DD");
          const response = await cashflow.cashflowdim10export(model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    isValueNonZero: function (val) {
      if (val === null || val === undefined || val === "") return false;
      return Number(val) !== 0;
    },
    drillDownListTrx: function (kol, row) {
      const val = row[`K${kol.kode.trim()}`];
      if (row.kode && this.isValueNonZero(val)) {
        let routeData = router.resolve({
          name: "treasury.cashflowdimtrx",
          params: {
            DimCol: kol.DimColName,
            DimVal: kol.kode,
            DimValInfo: kol.display,
            kodeaw: row.kode,
            tgl1: this.filter.tgl1,
            tgl2: this.filter.tgl2,
          },
          query: {
            sourceData: this.filter.sourceData || "TRANBANK",
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    drillDownTotal: function (row) {
      if (row.kode && this.isValueNonZero(row.total)) {
        let routeData = router.resolve({
          name: "treasury.cashflowgl",
          params: {
            kodeaw: row.kode,
            tgl1: this.filter.tgl1,
            tgl2: this.filter.tgl2,
          },
          query: {
            sourceData: this.filter.sourceData || "TRANBANK",
          },
        });
        window.open(routeData.href, "_blank");
      }
    },

    close() {
      router.push("home");
    },
  },
};
</script>
